import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams, useLocation } from "react-router-dom";

import { Card } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";

import completeSetupStyles from "./CompleteSetupStyles";

import { APP_ROUTES, BUTTON_TEXT_CONSTANT, CURRENT_COUNTRY, DELIVERY_TYPE, NEW_PATH_SELECTED } from "../../config/constants";
import { getServicePropositionDeliveryType, isObjectEmpty } from "../../utils/helperFunctions";
import { selectUserDetails } from "../Login/redux/userSlice";
import { fetchPOSBasicInformation, fetchTemplateSlotsByServiceType, fetchTemplateSlotsForStandard, resetCompleteSetupStore } from "./redux/completeSetupSlice";
import { getCurrentUrl } from "../../utils/ApplicationUtils";
import { isEmptyOrNull } from "utils/DataUtils";

import PageTitle from "../common/PageTitle/PageTitle";
import PrimaryButton from "../common/PrimaryButton/PrimaryButton";
import BasicInformation from "./BasicInformation/BasicInformation";
import FBCInformation from "./FBC/FBCInformation";
import SlotsInformation from "./SlotsInformation/SlotsInformation";
import useCommonDataConfig from "../../config/redux/useCommonDataConfig";

const CompleteSetup = () => {
  const { posNo } = useParams();
  const location = useLocation();

  // Extract posNo from URL if not available in params
  const posNoFromUrl = posNo || location.pathname.split('/').pop();

  const classes = completeSetupStyles();
  const dispatch = useDispatch();

  const { fetchingBasicDetails, basicDetails, slots } = useSelector((state) => state.completeSetup);

  const { servicePropositionList } = useCommonDataConfig();
  const userInfo = useSelector(selectUserDetails);

  const [countryName, setCountryName] = useState();
  const [enableServiceType, setEnableServiceType] = useState([]);
  // Construct the message dynamically
  const errorMessage = basicDetails?.posNo === posNo
    ? `selected country - ${countryName}.`
    : `DOS.`;

  useEffect(() => {
    let storedCountry = localStorage.getItem(CURRENT_COUNTRY) ? JSON.parse(localStorage.getItem(CURRENT_COUNTRY)) : undefined;
    const currentLocation = getCurrentUrl();
    if (storedCountry) {
      setCountryName(storedCountry.name);
    }
    if (!isEmptyOrNull(currentLocation)) {
      localStorage.setItem(NEW_PATH_SELECTED, currentLocation);
    }
  }, []);

  useEffect(() => {
    if (!isEmptyOrNull(basicDetails?.services)) {
      let serviceType = basicDetails?.services?.filter((item) => userInfo?.userProfile?.serviceTypeId.includes(item?.id));
      setEnableServiceType(serviceType);
    }
  }, [basicDetails, userInfo?.userProfile?.serviceTypeId]);

  useEffect(() => {
    return () => dispatch(resetCompleteSetupStore());
  }, [dispatch]);

  useEffect(() => {
    if (servicePropositionList?.length) {
      dispatch(fetchPOSBasicInformation(posNoFromUrl));
    }
  }, [dispatch, posNoFromUrl, servicePropositionList]);

  useEffect(() => {
    if (!fetchingBasicDetails && enableServiceType && basicDetails.posNo) {
      enableServiceType.forEach((s) => {
        if (getServicePropositionDeliveryType(servicePropositionList, s?.name) === DELIVERY_TYPE.SLOT_BASED) {
          dispatch(fetchTemplateSlotsForStandard({ posNo: posNoFromUrl, serviceType: s.id, serviceTypeName: s.name }));
        } else {
          dispatch(fetchTemplateSlotsByServiceType({ posNo: posNoFromUrl, serviceType: s.id, serviceTypeName: s.name }));
        }
      });
    }
  }, [dispatch, enableServiceType, fetchingBasicDetails, posNoFromUrl, basicDetails.posNo, servicePropositionList]);

  return (
    <div className={classes.completeSetup}>
      <PageTitle title={`POS(${posNoFromUrl})`} />
      {(!basicDetails.posNo && fetchingBasicDetails) || basicDetails.country === countryName ? (
        <>
          <BasicInformation loading={fetchingBasicDetails} posDetails={basicDetails} userInfo={userInfo} />
          {!isObjectEmpty(slots) &&
            !isObjectEmpty(basicDetails) &&
            enableServiceType.map((s) =>
              s.name === "FBC" ? (
                <FBCInformation key={s.id} posNo={basicDetails.posNo} userInfo={userInfo} serviceTypeName={s.name} serviceTypeId={s.id} slotsInformation={slots[s.name]} slots={slots} />
              ) : (
                <SlotsInformation
                  key={s.id}
                  userInfo={userInfo}
                  posDetails={basicDetails}
                  posNo={basicDetails.posNo}
                  serviceTypeDisplayName={s?.displayName || s?.name || ""}
                  serviceTypeName={s.name}
                  serviceTypeId={s.id}
                  slotsInformation={slots[s.name]}
                />
              )
            )}
        </>
      ) : (
        <Card style={{ padding: "10px", margin: "10px" }}>
          <Grid container style={{ marginLeft: "20%", fontWeight: "600", color: "red" }}>
            {`Pos - ${posNoFromUrl}, does not exist in ${errorMessage}`}
          </Grid>
        </Card>
      )}

      <Grid container direction="row" className={classes.footerButton}>
        <Grid item xs={6}>
          <Grid container spacing={1} justifyContent="flex-start">
            <Grid item className={classes.footerButtonsStyle}>
              <Link to={`${APP_ROUTES.POS_LIST}`} className={classes.linkstyle}>
                <PrimaryButton buttonLabel={`${BUTTON_TEXT_CONSTANT.BACK_TO_POS_LIST}`} buttonVariant="outlined" disabled={false} />
              </Link>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <Grid container spacing={1} justifyContent="flex-end"></Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default React.memo(CompleteSetup);
